import { FC } from 'react'
import { Text, useTimeFormat } from '@revolut-internal/ui-kit'

import { MessageColorSchema } from 'components/ChatMessage/ChatMessage.types'

interface MessageDateProps {
  createdAt: string
  colorSchema: MessageColorSchema
}

export const MessageDate: FC<MessageDateProps> = ({ createdAt, colorSchema }) => {
  const timeFormat = useTimeFormat({
    style: 'precise',
  })

  return (
    <Text
      whiteSpace="wrap"
      variant="small"
      ml="s-8"
      mt="s-4"
      color={colorSchema.date}
      style={{ float: 'right' }}
    >
      {timeFormat(new Date(createdAt))}
    </Text>
  )
}
